export class FormAddressAutocomplete {

    constructor() {
        const $postalCode = $('.js-auto-address-postalcode');
        const $houseNumber = $('.js-auto-address-housenumber');
        const $suffix = $('.js-auto-address-suffix');

        // bind events
        $postalCode.add($houseNumber).add($suffix).on('focusout', e => this.checkAddress(e));
			  $postalCode.on('focusout', e => this.removeSpaces(e));
    }

    removeSpaces(e) {
        const $el = $(e.currentTarget);
        const value = $el.val().replace(/\s/g, '');
			  $el.val(value);
    }

    checkAddress(e) {
        this.$container = $(e.currentTarget).closest('.js-address-autocomplete-container');
        this.$postalCode = this.$container.find('.js-auto-address-postalcode');
        this.$houseNumber = this.$container.find('.js-auto-address-housenumber');
        this.$suffix = this.$container.find('.js-auto-address-suffix');
        this.$street = this.$container.find('.js-auto-address-street');
        this.$city = this.$container.find('.js-auto-address-city');
        this.$country = this.$container.find('.js-auto-address-country');

        const postalCode = this.$postalCode.val();
        const housenumber = this.$houseNumber.val();
        const suffix = this.$suffix.val();

        if (0 === this.$city.val().length &&
            0 === this.$street.val().length &&
            0 < postalCode.length &&
            0 < housenumber.length) {
            this.completePostcodeExtension(postalCode, housenumber, suffix);
        }
    }


    /**
     * Function that completes the postcode with extension for the streetnumber
     *
     * @param postcode
     * @param housenumber
     * @param suffix
     */
    completePostcodeExtension(postcode, housenumber, suffix = null) {
        let url = "https://api.pro6pp.nl/v1/autocomplete?auth_key=AF5rfrU8BidZyJBI&nl_sixpp=" + postcode + "&streetnumber=" + housenumber;
        if (suffix) url += "&extension=" + suffix;

        return $.getJSON(url).then(data => this.preFillAddress(data));
    }

	  /**
     * Fills the street and address fields if there are no errors
	   * @param data
	   */
	  preFillAddress(data) {
        if (!data.error) {
            this.$street.val(data.results[0].street);
            this.$city.val(data.results[0].city);
					  this.$country.val('151'); // country code for the Nederlands
				}
    }

}
